import { platform } from '@/Models.js';

export function getExternalPlatformIcon(platformType) {
    return {
        [platform.ideafound]: '/content/images/indiegogo-logo.svg',
        [platform.gamefound]: '/content/images/gamefound-logo.svg',
    }[platformType];
}